import { Lens } from "src/app/shared/utilities/state/Optics";
import { SegmentState } from "./segment.models";

const stateLensProp = Lens.fromProp<SegmentState>();
export const pageViewLens = stateLensProp("pageView");
export const optInMarketingCommunicationsLens = stateLensProp(
  "optInMarketingCommunications"
);
